import { render, staticRenderFns } from "./w-divider.vue?vue&type=template&id=4fa73e8d&scoped=true"
import script from "./w-divider.vue?vue&type=script&lang=ts"
export * from "./w-divider.vue?vue&type=script&lang=ts"
import style0 from "./w-divider.vue?vue&type=style&index=0&id=4fa73e8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa73e8d",
  null
  
)

export default component.exports